<div class="container-fluid" style="margin-top:100px">
    <div class="row">
        <div class="col-sm-3">
        </div>
        <div class="col-sm-6">
            <p>
            <h1>SUKANDA ONELINK</h1>
            <p>
            <h4>Cookie Policy</h4>
            <p>
            <h5>Cookies</h5>
            <p class="text-justify">
                To make this site work properly and to give you the best possible experience, we sometimes place small
                data files called cookies on your device. Most big websites do this too.
            </p>
            <h5>What are cookies?</h5>
            <p class="text-justify">
                A cookie is a small text file that a website saves on your computer or mobile device when you visit the
                site. It enables the website to remember your actions and preferences (such as login, language, font
                size and other display preferences) over a period of time, so you don’t have to keep re-entering them
                whenever you come back to the site or browse from one page to another.
            </p>
            <h5>How do we use cookies?</h5>
            <p class="text-justify">
                When you visit our Websites, we may place a number of cookies in your browser. These are known as First
                Party Cookies and are required to enable to hold session information as you navigate from page to page
                within the website. For example, we use cookies on our websites to understand visitor and user
                preferences, such as language, which improves their experience, and track and analyse usage,
                navigational and other statistical information.
            </p>
            <p class="text-justify">
                We also use some third-party applications that place cookies in your browser for analytics and targeting
                so that we can improve our content and report on our performance. The cookie-related information is not
                used to identify you personally and the pattern data is fully under our control. These cookies are not
                used for any purpose other than those described here.
            </p>
            <p class="text-justify">
                List of cookies used on SUKANDA ONELINK sites:
            </p>
            <div class="table-responsive">
            <table class="table table-striped">
                <thead>
                    <tr>
                        <th>Website Name</th>
                        <th>Cookie</th>
                        <th>Info</th>
                        <th>Period</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td>www.sukandaonelink.com</td>
                        <td>User_info</td>
                        <td>Holds the user’s culture to determine display language</td>
                        <td>Permanent</td>
                    </tr>
                    <tr>
                        <td>www.sukandaonelink.com</td>
                        <td>Default_view</td>
                        <td>When starting an order if the default Catalog view is set to “Last View”, holds the user’s
                            last Catalog view.</td>
                        <td>Permanent</td>
                    </tr>
                    <tr>
                        <td>Imperva (Incapsula)</td>
                        <td>See</td>
                        <td>These cookies may be used by our firewall provider for security purposes.</td>
                        <td>Third</td>
                    </tr>
                    <tr>
                        <td>idp.pepperi.com</td>
                        <td>idsrv</td>
                        <td>Login authentication</td>
                        <td>Permanent (when selecting “Keep me logged in” upon login)</td>
                    </tr>
                    <tr>
                        <td>idp.pepperi.com</td>
                        <td>idsrv.session</td>
                        <td>Login authentication</td>
                        <td>Permanent (when selecting “Keep me logged in” upon login)</td>
                    </tr>
                    <tr>
                        <td>idp.pepperi.com</td>
                        <td>pepperi.webapplogin </td>
                        <td>Login authentication</td>
                        <td>Permanent (when selecting “Keep me logged in” upon login)</td>
                    </tr>
                    <tr>
                        <td>idp.pepperi.com</td>
                        <td>pepperi.last_auth</td>
                        <td>Login authentication</td>
                        <td>Session</td>
                    </tr>
                </tbody>
            </table>
            </div>
            <h5>How to control cookies?</h5>
            <p class="text-justify">
                You can <b>control and/or delete</b> cookies as you wish - for details, see aboutcookies.org. You can
                delete
                all cookies that are already on your computer and you can set most browsers to prevent them from being
                placed. If you do this, however, you may have to manually adjust some preferences every time you visit a
                site and some services and functionalities may not work.
            </p>
        </div>
        <div class="col-sm-3">
        </div>
    </div>
</div>